// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--n0nxo","header":"a10a3f92e9--header--s6rFs","list":"a10a3f92e9--list--jHl8z"};